const API_BASE = "https://assocham.org/assocham_backend/api";
 
export async function fetchInstagramFeed(limit = 12) {
  const res = await fetch(`${API_BASE}/instagram-feed.php?limit=${limit}`);
  if (!res.ok) {
    throw new Error(`Instagram feed request failed: ${res.status}`);
  }
  const json = await res.json();
  if (!json.success) {
    throw new Error(json.error || "Instagram feed error");
  }
  return json.data;
}
 